import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import titleImg from '../../../asset/img/address_title_img.svg';

import SlideRightDialog from '../../../components/common/SlideRightDialog';
import SubTitleSection from '../../../components/SubTitleSection';
import TabSection from './TabSection';
import Content from './Content';
import AddressInput from './AddressInput';
import Button from '../../../components/common/Button';
import { getAddress, resetOriginalAddressList, setAddress } from '../myInfoSlice';
import { getAlertMessageFunction } from '../../../common/Util';
import TextField from '../../../components/common/TextField';
import Typography from '../../../components/common/Typography';

const Address = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const { t: tCommon } = useTranslation('common');
  const { t } = useTranslation('myInfo');
  const { originalAddressList } = useSelector(state => state.myInfo);
  const [activeTab, setActiveTab] = useState(0);
  // 주소검색용
  const [addressInput, setAddressInput] = useState('');
  // 상세
  const [detailAddress, setDetailAddress] = useState('');
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true); // 추가
  const PAGE_SIZE = 10; // 페이지당 데이터 수 설정

  const clickSearchButton = async () => {
    const alertMessage = getAlertMessageFunction();
    if (addressInput?.trim() === '') {
      alertMessage(t('address.alertMessage01'));
      return;
    }
    setPage(1);
    setHasMore(true); // 검색 시 초기화
    let CMD = '';
    activeTab == '1' && (CMD = 'Jibun');
    let data = { search: addressInput, start: 1 };
    const response = await dispatch(getAddress({ CMD, data })).unwrap();

    // 받아온 데이터가 PAGE_SIZE보다 작으면 더 이상 데이터가 없다고 판단
    if (!response || response.length < PAGE_SIZE) {
      setHasMore(false);
    }
  };

  const handleLoadMore = useCallback(async () => {
    if (!originalAddressList || originalAddressList.length === 0 || !hasMore) return;

    const nextPage = page + 1;
    setPage(nextPage);

    let CMD = '';
    activeTab == '1' && (CMD = 'Jibun');
    let data = { search: addressInput, start: nextPage };

    const response = await dispatch(getAddress({ CMD, data })).unwrap();

    // 받아온 데이터가 PAGE_SIZE보다 작으면 더 이상 데이터가 없다고 판단
    if (!response || response.length < PAGE_SIZE) {
      setHasMore(false);
    }
  }, [page, addressInput, activeTab, originalAddressList, hasMore, dispatch]);

  const handleSave = () => {
    const alertMessage = getAlertMessageFunction();
    if (!addressInput) {
      alertMessage(t('address.alertMessage01'));
      return;
    }

    dispatch(setAddress(addressInput));
    handleClose();
  };

  const handleClose = () => {
    console.log('handleClose');
    setAddressInput('');
    setDetailAddress('');
    setActiveTab(0);
    setPage(1);
    setHasMore(true);
    dispatch(resetOriginalAddressList());
    onClose();
  };

  return (
    <SlideRightDialog isOpen={isOpen} onClose={handleClose} title={tCommon('header.title12')}>
      <div className="displayFlexColumn" style={{ gap: '16px' }}>
        <SubTitleSection title={t('address.title')} img={titleImg} />
        {/* 도로명,지번, 직접입력 */}
        <TabSection {...{ activeTab, setActiveTab }} />

        {activeTab == 2 && (
          <Typography className="body2Medium" style={{ whiteSpace: 'pre-wrap' }}>
            {`찾으시려는 도로명주소, 지번주소로 검색되지 않는 경우 주소를 직접 입력해 주세요.`}
          </Typography>
        )}

        <AddressInput {...{ activeTab, addressInput, setAddressInput }} />
        <Button
          value={activeTab === 2 ? t('address.save') : t('address.searchButton')}
          size="large"
          onClick={activeTab === 2 ? handleSave : clickSearchButton}
        />

        {/* 내용 */}
        {activeTab != 2 && (
          <Content activeTab={activeTab} onClose={handleClose} onLoadMore={handleLoadMore} />
        )}
      </div>
    </SlideRightDialog>
  );
};

export default Address;
